export default "__VITE_PUBLIC_ASSET__f30187af__"